/* eslint-disable react/react-in-jsx-scope */
import type { NextPage } from 'next';

import GreenReturnsLayout from '@/components/GreenReturnsLayout';
import GreenReturnPageLayout from '@/containers/GreenReturns/GreenReturnsPageLayout';

const GreenReturns: NextPage = () => (
  <GreenReturnsLayout
    url="green-future-2024"
    ogTitle="IVCA GreenReturn Summit aims to serve as a crucial crucible for facilitating dialogues and interactions for climate finance to find the appropriate investments."
    title="GreenReturns"
    description="The summit will feature in-depth discussions on policy, investments, regulations, and technological aspects of climate change investing in India. Innovations in financial, regulatory, and business processes will be explored to drive impactful solutions suited to the needs of the global South."
  >
    <GreenReturnPageLayout />
  </GreenReturnsLayout>
);

export default GreenReturns;
